<template>
  <div class="login-block">
    <div class="col-10 col-sm-8 col-xl-3">
      <el-card>
        <div class="card-title fs-4 pb-3">
          ВХОД
        </div>
        <el-form
          size="large"
          ref="form"
          :model="form"
          class="text-start"
          status-icon
          label-width="auto">
          <el-form-item prop="email"
                        :rules="[
        {
          required: true,
          message: 'Введите адрес электронной почты',
          trigger: 'blur',
        },
        {
          type: 'email',
          message: 'Введите правильный адрес электронной почты.',
          trigger: ['blur', 'change'],
        },
      ]">
            <el-input :prefix-icon="User" :suffix-icon="Message" placeholder="E-mail" v-model="form.email" type="text"
                      autocomplete="off" />
          </el-form-item>

          <el-form-item prop="password"
                        :rules="[{ required: true, message: 'Обязательно для заполнение'}]">
            <el-input :prefix-icon="More" placeholder="Password" v-model="form.password" type="password"
                      autocomplete="off" show-password />
          </el-form-item>

          <el-form-item>
            <div class="w-100 text-end">
              <el-button type="success" :loading="isLoading" @click="loginIn">Вход</el-button>
            </div>
          </el-form-item>
          <div class="alt-link text-center mt-3">
            Нет аккаунта? <router-link to="/register">Зарегистрироваться</router-link><br />
            <router-link to="/forgot-password">Забыли пароль?</router-link>
          </div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script lang="js">
import { Message, More, User } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import store from '@/components/store/store'
import { useCookies } from 'vue3-cookies'

export default {
  name: 'LoginBlock',
  computed: {
    Message() {
      return Message
    },
    More() {
      return More
    },
    User() {
      return User
    }
  },
  setup() {
    const cookies = useCookies(['token']);
    return {
      cookies
    }
  },
  data() {
    return {
      form: {
        email: null,
        password: null
      },
      isLoading: false,
      isError: false
    }
  },
  methods: {
    async loginIn() {
      this.isLoading = true
      try {
        await this.$refs.form.validate()
      } catch (e) {
        ElMessage.error('Заполните необходимые поля');
        this.isLoading = false;
        return
      }
      store.dispatch('auth/checkLogin', { form: this.form }).then((res) => {
        if (!res?.success) {
          ElMessage.error('Неверный логин или пароль!');
        }
        this.isLoading = false;
      });
    }
  }
}
</script>
<style scoped>
.login-block {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.alt-link {
  margin-top: 16px;
  text-align: center;
  font-size: 14px;
}
</style>
